var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroundGrassSky(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3 140",
    width: 3,
    height: 140,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ground Grass Sky-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m724.75-92v562.75h-999.75v-562.75z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #c0eafe } \n\t\t.s1 { fill: #c0e9fe } \n\t\t.s2 { fill: #e9d9d0 } \n\t\t.s3 { fill: #e9dad1 } \n\t\t.s4 { fill: #d3f9e6 } \n\t\t.s5 { fill: #d4fae7 } \n\t\t.s6 { fill: #191917 } \n\t\t.s7 { fill: #181b19 } \n\t\t.s8 { fill: #000000 } \n\t\t.s9 { fill: #0e0f0d } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-275-92c329.9 0 659.8 0 999.8 0 0 185.7 0 371.4 0 562.7-330 0-659.9 0-999.8 0 0-185.7 0-371.4 0-562.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-275-92c329.9 0 659.8 0 999.8 0 0 77.2 0 154.3 0 233.9-330 0-659.9 0-999.8 0 0-77.2 0-154.4 0-233.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-275 48.6c329.9 0 659.8 0 999.8 0 0 30.7 0 61.5 0 93.3-330 0-659.9 0-999.8 0 0-30.8 0-61.6 0-93.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-275 423.2c329.9 0 659.8 0 999.8 0 0 15.7 0 31.4 0 47.5-330 0-659.9 0-999.8 0 0-15.6 0-31.3 0-47.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-275 282.7c329.9 0 659.8 0 999.8 0 0 15.6 0 31.3 0 47.5-330 0-659.9 0-999.8 0 0-15.7 0-31.4 0-47.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-275 141.9c329.9 0 659.8 0 999.8 0 0 15.6 0 31.3 0 47.5-330 0-659.9 0-999.8 0 0-15.7 0-31.4 0-47.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-275 1.3c329.9 0 659.8 0 999.8 0 0 15.6 0 31.2 0 47.3-330 0-659.9 0-999.8 0 0-15.6 0-31.2 0-47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m-275 236.1c329.9 0 659.8 0 999.8 0 0 15.4 0 30.7 0 46.6-330 0-659.9 0-999.8 0 0-15.4 0-30.7 0-46.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m-275 377c329.9 0 659.8 0 999.8 0 0 15.2 0 30.5 0 46.2-330 0-659.9 0-999.8 0 0-15.2 0-30.5 0-46.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m-275 95.6c329.9 0 659.8 0 999.8 0 0 15.3 0 30.5 0 46.3-330 0-659.9 0-999.8 0 0-15.3 0-30.6 0-46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m-275-45c329.9 0 659.8 0 999.8 0 0 15.3 0 30.6 0 46.3-330 0-659.9 0-999.8 0 0-15.3 0-30.5 0-46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m-275 423.2c329.9 0 659.8 0 999.8 0q0 0.6 0 1.3c-330 0-659.9 0-999.8 0q0-0.6 0-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-275 141.9c329.9 0 659.8 0 999.8 0q0 0.6 0 1.2c-330 0-659.9 0-999.8 0q0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-275 282.7c329.9 0 659.8 0 999.8 0q0 0.5 0 1c-330 0-659.9 0-999.8 0q0-0.5 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m-275 1.3c329.9 0 659.8 0 999.8 0q0 0.5 0 1c-330 0-659.9 0-999.8 0q0-0.5 0-1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundGrassSky);
export default __webpack_public_path__ + "static/media/groundGrassSky.149921114c38e7ad2245d74c8154cdf8.svg";
export { ForwardRef as ReactComponent };